module.exports = __webpack_public_path__ + "static/media/35.eaade0dd.mp3";